import requestModel from "services/config/apiHandlers";

class Users {
  constructor(requsetObj) {
    this.requsetObj = requsetObj;
    this.url = "api/users/";
  }

  async postLogin() {
    const apiObj = {
      url: this.url + "login",
      method: "post",
      reqObj: this.requsetObj,
    };

    return await requestModel.response(apiObj);
  }

  async postSendValidationCode() {
    const apiObj = {
      url: this.url + "send-validation-code",
      method: "post",
      reqObj: this.requsetObj,
    };

    return await requestModel.response(apiObj);
  }

  async postVerifyValidationCode() {
    const apiObj = {
      url: this.url + "verify-validation-code",
      method: "post",
      reqObj: this.requsetObj,
    };

    return await requestModel.response(apiObj);
  }

  async postSignUp() {
    const apiObj = {
      url: this.url + "signup",
      method: "post",
      reqObj: this.requsetObj,
    };

    return await requestModel.response(apiObj);
  }

  async postLogout() {
    const apiObj = {
      url: this.url + "logout",
      method: "post",
    };

    return await requestModel.response(apiObj);
  }

  async postResetPassword() {
    const apiObj = {
      url: this.url + "reset-password",
      method: "post",
      reqObj: this.requsetObj,
    };

    return await requestModel.response(apiObj);
  }

  async getProfile() {
    const apiObj = {
      url: this.url + "profile",
    };

    return await requestModel.response(apiObj);
  }

  async patchChangePassword() {
    const apiObj = {
      url: this.url + "change-password",
      method: "patch",
      reqObj: this.requsetObj,
    };

    return await requestModel.response(apiObj);
  }

  async putEditUsers() {
    const apiObj = {
      url: this.url,
      method: "put",
      reqObj: this.requsetObj,
    };

    return await requestModel.response(apiObj);
  }
}

export default Users;
